// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3q2jP","column":"style_column__2x3dS","row":"style_row__37jS5"};